import fr from 'facet-rest';

function createLinkFromURL(url) {
  return new fr.Link({ data: { url: url.toString() } });
}

/**
 * Extracts the 'index' query parameter from a provided API link, removes it from the link,
 * and returns both the modified link and the extracted index value.
 *
 * This function assumes the index is a top-level query parameter in the provided link.
 *
 * @param {string} link - The full URL string with the index parameter.
 * @param {string} paramKey - The param key.
 * @returns {{cleanedLink: fr.Link, paramValue: string | null}}
 */
export function extractParamFromLink(link, paramKey) {
  if (!link) {
    return { cleanedLink: undefined, paramValue: null };
  }

  // Use a URL object to safely parse and modify the link.
  // We use a mock base to ensure the URL object can be constructed even if the link is relative.
  let url;
  try {
    url = new URL(link);
  } catch (error) {
    return { cleanedLink: createLinkFromURL(link), paramValue: null };
  }

  const params = url.searchParams;
  const paramValue = params.get(paramKey);

  if (paramValue === null) {
    // If index is not present, return the original link
    return { cleanedLink: createLinkFromURL(link), paramValue: null };
  }

  // 1. Remove the 'index' parameter from the URLSearchParams object
  params.delete(paramKey);

  // 2. Reconstruct the cleaned link by removing the mock base if it was used
  // and ensuring the search string is correctly appended.
  const cleanedLink = createLinkFromURL(url);

  return {
    cleanedLink,
    paramValue,
  };
}
